import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface SidebarProps {
  version: string
}

export default function Sidebar({ version }: SidebarProps) {
  const [areaClienteOpen, setAreaClienteOpen] = useState(false)
  const navigate = useNavigate()

  const handleNavigation = (path: string) => {
    navigate(path)
  }

  return (
    <nav id="sidebar">
      <div className="p-4 pt-4">
        <a href="#/" className="logo" onClick={(e) => { e.preventDefault(); navigate('/') }}>
          <img 
            alt="Mainengine Consultoria em Sistemas" 
            src="images/logomainengine.jpg" 
            width="173" 
            height="43" 
          />
        </a>
        <ul className="list-unstyled components mb-5">
          <li>
            <a 
              href="#/quem-somos"
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('/quem-somos')
              }}
            >
              <i className='fa fa-home' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
              Quem Somos
            </a>
          </li>
          <li>
            <a 
              href="#/servicos"
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('/servicos')
              }}
            >
              <i className='fa fa-gear' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
              Serviços
            </a>
          </li>
          <li>
            <a 
              href="#/produtos"
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('/produtos')
              }}
            >
              <i className='fa fa-cubes' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
              Produtos
            </a>
          </li>
          <li>
            <a 
              href="#/tecnologia"
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('/tecnologia')
              }}
            >
              <i className='fa fa-superscript' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
              Tecnologia
            </a>
          </li>
          <li>
            <a 
              href="#/clientes"
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('/clientes')
              }}
            >
              <i className='fa fa-group' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
              Nossos Clientes
            </a>
          </li>
          <li>
            <a 
              href="#/contato"
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('/contato')
              }}
            >
              <i className='fa fa-comments' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
              Contato
            </a>
          </li>
          <li>
            <a 
              href="#sistemaSubmenuAreaCliente" 
              onClick={(e) => {
                e.preventDefault()
                setAreaClienteOpen(!areaClienteOpen)
              }}
              className="dropdown-toggle"
            >
              <i className='fa fa-wpforms' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
              Área para Clientes
            </a>
            <ul className={`collapse list-unstyled ${areaClienteOpen ? 'show' : ''}`} id="sistemaSubmenuAreaCliente">
              <li>
                <a 
                  href={`index.html?sub=centralproc&rt=cproc_central&v=${version}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className='fa fa-gears' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                  Painel de Processamentos
                </a>
              </li>
              <li>
                <a 
                  href="index.html?rt=acessos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className='fa fa-unlock' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                  Controle de Acessos
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <div className="footer">
          <p>&copy; Copyright 1997-{new Date().getFullYear()} MainEngine®</p>
        </div>
      </div>
    </nav>
  )
}
